export const commonBlockProps = {
  required: false,
};

export const commentsProps = {
  commentsEnabled: false,
  commentsLabel: 'Comments',
};

export default settings => ({
  ...commonBlockProps,
  ...settings,
});
